///
/// This file contains enums that are used by the DB schemas and also have to appear in API contracts that the
/// front end uses. These enums will end up in the frontend bundle.
///

export enum LeaderboardAction {
  TRUSTPILOT_REVIEW = 'TRUSTPILOT_REVIEW',
  FACEBOOK_REVIEW = 'FACEBOOK_REVIEW',
  GOOGLE_REVIEW = 'GOOGLE_REVIEW',
  INSTAGRAM_FOLLOW = 'INSTAGRAM_FOLLOW',
  MAILING_LIST_BONUS = 'MAILING_LIST_BONUS',
  AJ385_SURVEY = 'AJ385_SURVEY',
  SUGGEST_PRIZE = 'SUGGEST_PRIZE',
  REFER_FRIEND_TOKEN_REWARD = 'REFER_FRIEND_TOKEN_REWARD',
  REFER_FRIEND = 'REFER_FRIEND',
  ENTER_DAILY_CHALLENGER = 'ENTER_DAILY_CHALLENGER',
  VIDEO_TESTIMONIAL = 'VIDEO_TESTIMONIAL',
  EXCHANGE_TOKEN = 'EXCHANGE_TOKEN',
  GENERIC_BONUS = 'GENERIC_BONUS',
  WEEKLY_DRAW_FREEMIUM = 'WEEKLY_DRAW_FREEMIUM',
  LOTTERY_ENTRY = 'LOTTERY_ENTRY',
  RAFFLE_ENTRY = 'RAFFLE_ENTRY',
  DAILY_POUND_RAFFLE = 'DAILY_POUND_RAFFLE',
  SUBSCRIBER_BONUS = 'SUBSCRIBER_BONUS',

  TRUSTPILOT_REVIEW_CARRIED_OVER = 'TRUSTPILOT_REVIEW_CARRIED_OVER',
  FACEBOOK_REVIEW_CARRIED_OVER = 'FACEBOOK_REVIEW_CARRIED_OVER',
  GOOGLE_REVIEW_CARRIED_OVER = 'GOOGLE_REVIEW_CARRIED_OVER',
  INSTAGRAM_FOLLOW_CARRIED_OVER = 'INSTAGRAM_FOLLOW_CARRIED_OVER',
  SUBSCRIBER_BONUS_CARRIED_OVER = 'SUBSCRIBER_BONUS_CARRIED_OVER',
}

export enum PurchasingAction {
  GOODWILL = 'GOODWILL',
  POSTAL = 'POSTAL',
  PRIZE = 'PRIZE',
  PROMO = 'PROMO',
  PURCHASE_TOKEN = 'PURCHASE_TOKEN',
  REDEEM_TOKEN = 'REDEEM_TOKEN',
  REFERRAL = 'REFERRAL',
  REWARD = 'REWARD',
  SUBSCRIPTION = 'SUBSCRIPTION',
  SUBSCRIPTION_UPGRADE = 'SUBSCRIPTION_UPGRADE',
  SUBSCRIPTION_INITIAL = 'SUBSCRIPTION_INITIAL',
  WINNER_CONTENT = 'WINNER_CONTENT',
  LEADERBOARD = 'LEADERBOARD',
}

export enum FeedbackAction {
  CLAIM_PRIZE_WIN = 'CLAIM_PRIZE_WIN',
  CANCEL_SUBSCRIPTION = 'CANCEL_SUBSCRIPTION',
  TOKEN_TOWN = 'TOKEN_TOWN',
  SUGGEST_PRIZE = 'SUGGEST_PRIZE',
}

export enum FeedbackRefKey {
  prizeWin = 'prize_win',
  subscription = 'subscription',
  noKey = 'no_key',
}

export enum DrawScheduleStatus {
  ACTIVE = 'ACTIVE',
  DISABLED = 'DISABLED',
}

export enum DrawStatus {
  SCHEDULED = 'SCHEDULED',
  INPROGRESS = 'INPROGRESS',
  RESULTED = 'RESULTED',
  AWARDING = 'AWARDING',
  PRIZES_AWARDED = 'PRIZES_AWARDED',
  COMPLETED = 'COMPLETED',
  CANCELLED = 'CANCELLED',
}

// Define enums for action and ref_key constraints
export enum TreeAction {
  INITIAL_ENTRY = 'INITIAL_ENTRY',
  TOKEN_EXCHANGE_TREE = 'TOKEN_EXCHANGE_TREE',
  FREE_ENTRY_AND_EXTRA_TREE = 'FREE_ENTRY_AND_EXTRA_TREE',
  TICKET_PURCHASE = 'TICKET_PURCHASE',
  TREAT_EXCHANGED_TREE = 'TREAT_EXCHANGED_TREE',
  SUBSCRIPTION_RENEWAL = 'SUBSCRIPTION_RENEWAL',
  GIFT_CARD = 'GIFT_CARD',
  TOKEN_ORDER = 'TOKEN_ORDER',
  ACCOUNT_MERGE = 'ACCOUNT_MERGE',
}

export enum TreeStatus {
  PENDING = 'PENDING',
  CONFIRMED = 'CONFIRMED',
}

export enum TreeRefKey {
  player = 'player',
  leaderboard_contribution = 'leaderboard_contribution',
  token_redemption = 'token_redemption',
  gift_card = 'gift_card',
  subscription = 'subscription',
  prize_order_product = 'prize_order_product',
  ticket_order = 'ticket_order',
  ticket = 'ticket',
  order = 'order',
}

export enum PaymentMethod {
  ADYEN = 'ADYEN',
  CHECKOUT_COM = 'CHECKOUT_COM',
  PAYPAL = 'PAYPAL',
}

export enum PaymentCurrency {
  GBP = 'GBP',
  TOKEN = 'TOKEN',
}

export enum GameType {
  LOTTERY = 'LOTTERY',
  RAFFLE = 'RAFFLE',
  BIG_RAFFLE = 'BIG_RAFFLE',
  LEADERBOARD = 'LEADERBOARD', // Added for leaderboard draws
}

export enum PaymentStatus {
  PENDING = 'PENDING',
  SENT = 'SENT',
  APPROVED = 'APPROVED',
  FAILED = 'FAILED',
  REFUNDED = 'REFUNDED',
}

export enum PaymentRefType {
  ORDER = 'ORDER',
  SUBSCRIPTION = 'SUBSCRIPTION',
  INVITEDBY = 'INVITEDBY',
  PRIZE_ORDER_PRODUCT = 'PRIZE_ORDER_PRODUCT',
  GIVEAWAY = 'GIVEAWAY',
  TOKEN_REDEMPTION = 'TOKEN_REDEMPTION',
  TICKET_REFUND = 'TICKET_REFUND',
  GIFT_CARD_ORDER = 'GIFT_CARD_ORDER',
  MIGRATION = 'MIGRATION',
  MANUAL_ADJUSTMENT = 'MANUAL_ADJUSTMENT',
  CHANGE_PAYMENT_METHOD = 'CHANGE_PAYMENT_METHOD',
  SUBSCRIPTION_RUN = 'SUBSCRIPTION_RUN',
}

export enum TransactionType {
  CREDIT = 'CREDIT',
  DEBIT = 'DEBIT',
}

export enum PaymentSessionAction {
  ORDER = 'ORDER',
  RECURRING = 'RECURRING',
  CHANGEPAYMENTMETHOD = 'CHANGEPAYMENTMETHOD',
  REFUND = 'REFUND',
}

export enum OrderStatus {
  PENDING = 'PENDING',
  COMPLETED = 'COMPLETED',
  CANCELLED = 'CANCELLED',
}

export enum DrawOrderStatus {
  ACTIVE = 'ACTIVE',
  DELETED = 'DELETED',
}

export enum SubscriptionRunStatus {
  PENDING = 'PENDING',
  FAILING = 'FAILING',
  FAILED = 'FAILED',
  COMPLETED = 'COMPLETED',
  /**
   * Used when a recurring payment for this run is in flight with an async payment method
   * (e.g. Paypal via Checkout.com) and hasn't resolved yet
   */
  AWAITING_PAYMENT = 'AWAITING_PAYMENT',
}

export enum TicketStatus {
  PLACED = 'PLACED',
  RESULTED = 'RESULTED',
  CANCELLED = 'CANCELLED',
}

export enum PrizeDisplayGroup {
  HERO = 'HERO',
  TRENDING = 'TRENDING',
  TOP = 'TOP',
  LAST = 'LAST',
}

export enum PrizeStatus {
  VISIBLE = 'VISIBLE',
  HIDDEN = 'HIDDEN',
}

export enum PromoType {
  REFERRAL = 'REFERRAL',
  PROMO = 'PROMO',
  SYSTEM = 'SYSTEM',
}

export enum PromoStatus {
  PENDING = 'PENDING',
  ACTIVE = 'ACTIVE',
  SUSPENDED = 'SUSPENDED',
}

export enum PlayerStatus {
  ACTIVE = 'ACTIVE',
  CLOSED = 'CLOSED',
  CONTACT_ONLY = 'CONTACT_ONLY',
  GUEST = 'GUEST',
  SUSPENDED = 'SUSPENDED', // not used, to be removed when drizzle-kit can handle removing enum values properly
}

export enum WinType {
  PRIZE = 'PRIZE',
  TREAT = 'TREAT',
}

export enum TokenRedemptionOptionType {
  PRIZE = 'PRIZE',
  ENTRY = 'ENTRY',
  TREE = 'TREE',
}

export enum PromoAction {
  SUBSCRIPTION_PURCHASE = 'SUBSCRIPTION_PURCHASE',
  LEGACY = 'LEGACY',
}

export enum TokenRedemptionOptionGroup {
  GAME = 'GAME',
  PRIZE = 'PRIZE',
}

export enum TokenRedemptionOptionStatus {
  VISIBLE = 'VISIBLE',
  HIDDEN = 'HIDDEN',
}

export enum PromoRecurringStatus {
  COMPLETE = 'COMPLETE',
  INPROGRESS = 'INPROGRESS',
  CANCELLED = 'CANCELLED',
}

export enum GiveawayType {
  ENTRY = 'ENTRY',
  TOKEN = 'TOKEN',
  POINT = 'POINT',
  GIFTCARD = 'GIFTCARD',
  PRIZE = 'PRIZE',
}

export enum AuditAction {
  INSERT = 'INSERT',
  UPDATE = 'UPDATE',
  DELETE = 'DELETE',
}

/** RewardType, as used by promo codes */
export enum RewardType {
  DISCOUNT_PERCENTAGE = 'DISCOUNT_PERCENTAGE',
  DISCOUNT_ENTRY = 'DISCOUNT_ENTRY',
  DISCOUNT_ENTRY_PERCENTAGE = 'DISCOUNT_ENTRY_PERCENTAGE',
  FIXED_DISCOUNT = 'FIXED_DISCOUNT',
  FREE_ENTRY = 'FREE_ENTRY',
  LEGACY = 'LEGACY',
}

export enum SubscriptionStatus {
  PENDING = 'PENDING',
  ACTIVE = 'ACTIVE',
  INACTIVE = 'INACTIVE',
  SNOOZED = 'SNOOZED',
  CANCELLED = 'CANCELLED',
  FAILING = 'FAILING',
  FAILED = 'FAILED',
}

export enum PrizeOrderStatus {
  PENDING = 'PENDING',
  NEW = 'NEW',
  OPEN = 'OPEN',
  PROCESSING = 'PROCESSING',
  ON_HOLD = 'ON_HOLD',
  CANCELLED = 'CANCELLED',
  ORDER_DOWNLOADED = 'ORDER_DOWNLOADED',
  CONFIRMED = 'CONFIRMED',
}

export enum PrizeType {
  SINGLE = 'SINGLE',
  OPTION = 'OPTION',
  MULTI_OPTION = 'MULTI_OPTION',
  BUNDLE = 'BUNDLE',
  CUSTOM = 'CUSTOM',
}

export enum VendorCategory {
  BIG_BRAND = 'BIG_BRAND',
  GOOD_CAUSES = 'GOOD_CAUSES',
  SMALL_MEDIUM = 'SMALL_MEDIUM',
}

export enum PrizeTierType {
  MATERIAL = 'MATERIAL',
  IN_GAME = 'IN_GAME',
}

export enum ProductStatus {
  AVAILABLE = 'AVAILABLE',
  UNAVAILABLE = 'UNAVAILABLE',
  DISCONTINUED = 'DISCONTINUED',
}

export enum ProductType {
  PHYSICAL = 'PHYSICAL',
  DONATION = 'DONATION',
  ENTRY = 'ENTRY',
  CREDIT = 'CREDIT',
  GIFTCARD = 'GIFTCARD',
  PLACEHOLDER_MULTI_OPTION = 'PLACEHOLDER_MULTI_OPTION',
  PLACEHOLDER_LEGACY = 'PLACEHOLDER_LEGACY',
  CUSTOM = 'CUSTOM',
}

export enum ScheduledTaskStatus {
  ENABLED = 'ENABLED',
  DISABLED = 'DISABLED',
}

export enum TaskQueueType {
  GENERAL = 'GENERAL',
  SUBSCRIPTION = 'SUBSCRIPTION',
  RESULTING = 'RESULTING',
  LONG_RUNNING = 'LONG_RUNNING',
}

export enum TaskStatus {
  PENDING = 'PENDING',
  QUEUED = 'QUEUED',
  PROCESSING = 'PROCESSING',
  DONE = 'DONE',
  FAILED = 'FAILED',
}

/**
 * @readonly
 * @enum {string}
 * @property {string} PENDING Player has won a prize but has not yet been selected
 * @property {string} AWARDED CS Team has sent the prize to the player
 * @property {string} CHOSEN Player has selected a prize or pre-selected due to raffle type
 * @property {string} AWAITING_RESELECTION Player has chosen a prize, but there was an issue with their order, therefore allowed to reselect
 */
export enum PrizeWinStatus {
  PENDING = 'PENDING',
  AWARDED = 'AWARDED',
  CHOSEN = 'CHOSEN',
  AWAITING_RESELECTION = 'AWAITING_RESELECTION',
  CANCELLED = 'CANCELLED',
}

export enum TokenRedemptionStatus {
  PENDING = 'PENDING',
  COMPLETED = 'COMPLETED',
  CANCELLED = 'CANCELLED',
}

export enum TokenOrderStatus {
  PENDING = 'PENDING',
  COMPLETED = 'COMPLETED',
  CANCELLED = 'CANCELLED',
}

export enum EmailState {
  PENDING = 'PENDING',
  OPENED = 'OPENED',
  CLICKED = 'CLICKED',
  SENT = 'SENT',
  SENT_FROM_BREVO = 'SENT_FROM_BREVO',
}

export enum PromoPrizeRewardStatus {
  PENDING = 'PENDING',
  CHOSEN = 'CHOSEN',
  AWARDED = 'AWARDED',
  CANCELLED = 'CANCELLED',
}

export enum PromoPrizeRewardRefKey {
  DRAW = 'DRAW',
  TICKET_ENTRY = 'TICKET_ENTRY',
  GIVEAWAY = 'GIVEAWAY',
}

export enum ReferralScheme {
  GIVE12GET12 = 'GIVE12GET12',
  WINWITHFRIENDS = 'WINWITHFRIENDS',
}

export enum ReferralStatus {
  ACTIVE = 'ACTIVE',
  INACTIVE = 'INACTIVE',
}

export enum CmsDocumentStatus {
  DRAFT = 'DRAFT',
  PUBLISHED = 'PUBLISHED',
}

export enum ReportingLoggingEventName {
  RESET_EXPIRY = 'RESET_EXPIRY',
  RESET_PRIZE_CHOICE = 'RESET_PRIZE_CHOICE',
}

export enum CheckoutComPaymentResult {
  SUCCESS = 'SUCCESS',
  FAILURE = 'FAILURE',
}
